"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { PropsWithChildren, useState } from "react";
import { Toaster } from "sonner";
import { WagmiProvider } from "wagmi";

import { RouteAnalytics } from "./components/analytics/RouteAnalytics";
import { getWagmiConfig } from "./lib/wagmi";

export const Providers = ({ children }: PropsWithChildren) => {
  // Lazy initialization to avoid SSR issues with MetaMask SDK
  const [wagmiConfig] = useState(() => getWagmiConfig());

  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 1000 * 30,
            refetchOnWindowFocus: false,
          },
        },
      })
  );

  return (
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <RouteAnalytics />
        {children}
        <Toaster richColors position="top-right" />
      </QueryClientProvider>
    </WagmiProvider>
  );
};
